import React from 'react';

import Icon from '@components/icon';

import MirIcon from './MirIcon';
import JcbIcon from './JcbIcon';

import styles from './styles.modules.scss';

const BankCardIcons = () => (
    <div className={styles['bank-card-icons']}>
        <div className={styles['icon-group']}>
            <Icon
                className={styles['visa']}
                height="28"
                name="ic_visa-l"
                width="41"
            />
            <Icon
                className={styles['mastercard']}
                height="28"
                name="ic_mastercard"
                width="30"
            />
            <Icon
                className={styles['sberbank']}
                height="28"
                name="ic_sberbank"
                width="20"
            />
        </div>
        <div className={styles['icon-group']}>
            <MirIcon />
            <JcbIcon />
        </div>
    </div>
);

export default BankCardIcons;
